
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinpune() {



  const cardData =
  {
    keyword: 'Corporate Cab Service in Pune',
    heading: 'AB Ghule Cabs: Corporate Cab Service in Pune',
    headingDescription: 'AB Ghule Cabs provides professional and efficient corporate cab services in Pune, catering to the transportation needs of businesses, employees, and corporate clients. Whether it is for a business meeting, airport transfer, or daily commute, our fleet of reliable vehicles and experienced drivers ensure a smooth, comfortable, and timely journey for all your corporate travel requirements. With our affordable pricing, punctual service, and high standards of customer care, we are your trusted partner for all corporate transportation needs.',

    top: 'Top Reasons to Choose AB Ghule Cabs for Corporate Cab Service in Pune',

    "topPlaces": [
  {
    title: "Punctual Service",
    description: "Timeliness is crucial for corporate travel, and we ensure that all rides are on time. Our drivers are well-versed in the best routes to avoid delays and guarantee timely arrivals for meetings or flights."
  },
  {
    title: "Comfortable and Reliable Vehicles",
    description: "Choose from our fleet of well-maintained sedans, SUVs, and luxury cars. Our vehicles are equipped with modern amenities to ensure a comfortable and professional ride to your destination."
  },
  {
    title: "Experienced and Professional Drivers",
    description: "Our drivers are experienced and professional, trained to assist with your luggage and maintain a high standard of customer service. They are well-aware of the city’s roads and the fastest routes, ensuring a hassle-free journey."
  },
  {
    title: "Customized Packages for Corporates",
    description: "We offer tailored corporate cab packages to suit your specific requirements, whether it's for daily commuting, business meetings, airport transfers, or employee shuttles. Flexible options allow you to choose what fits your needs."
  },
  {
    title: "Affordable and Transparent Pricing",
    description: "We provide competitive pricing with no hidden charges. Our transparent pricing model ensures that you know the exact cost at the time of booking."
  },
  {
    title: "24/7 Availability",
    description: "Whether it’s an early morning meeting or a late-night airport drop, AB Ghule Cabs operates 24/7, ensuring that your transportation needs are met at any time of the day or night."
  },
  {
    title: "Corporate Accounts and Billing",
    description: "We offer corporate accounts and easy billing solutions for businesses, making it simple to track transportation expenses and make timely payments."
  },
  {
    title: "Safety and Cleanliness",
    description: "All our vehicles are regularly cleaned and sanitized to ensure your safety. We adhere to all safety protocols to ensure a hygienic and secure ride for every passenger."
  },
  {
    title: "Easy Booking and Payment Options",
    description: "Booking a corporate cab is quick and easy through our online platform or via phone. We also offer flexible payment options, including card and online payment methods."
  },
  {
    title: "No Surge Pricing",
    description: "Unlike ride-sharing services, we do not have surge pricing. The fare you see when booking is what you will pay, making your travel budget more predictable."
  }
],


services: [
    {
      "name": "Pune Corporate Cab Services",
      description: "AB Ghule Cabs provides premium corporate cab services in Pune, offering reliable and comfortable transportation for business professionals. Our fleet includes well-maintained vehicles to meet all your corporate travel needs."
    },
    {
      "name": "Pune Corporate Taxi Booking",
      description: "Easily book a taxi for corporate purposes in Pune with AB Ghule Cabs. Our hassle-free online booking system ensures you have a taxi ready for your business meetings, conferences, and corporate events."
    },
    {
      "name": "Pune Corporate Car Rental",
      description: "Looking for corporate car rental in Pune? AB Ghule Cabs offers flexible and affordable car rental options for corporate travel, whether it's for a day trip or a long-term contract."
    },
    {
      "name": "Pune Corporate Transportation Services",
      description: "AB Ghule Cabs provides comprehensive corporate transportation services in Pune. Our services are tailored to meet the specific needs of businesses, ensuring timely and efficient travel for employees and clients."
    },
    {
      "name": "Pune Corporate Car Hire",
      description: "Hire a car for your corporate needs with AB Ghule Cabs. We offer a variety of vehicles including luxury cars, sedans, and SUVs for business travel, ensuring a comfortable and stylish experience."
    },
    {
      "name": "Pune Corporate Taxi Rates",
      description: "AB Ghule Cabs offers competitive taxi rates for corporate travel in Pune. Our transparent pricing ensures no hidden charges, providing the best value for your business transportation needs."
    },
    {
      "name": "Pune Corporate Vehicle Rental",
      description: "For corporate vehicle rental in Pune, choose AB Ghule Cabs. We provide flexible rental options to meet the demands of your business, from short-term rentals to long-term contracts."
    },
    {
      "name": "Pune Corporate Taxi Packages",
      description: "AB Ghule Cabs offers customized corporate taxi packages in Pune, tailored to suit your specific requirements. Whether you need a one-time ride or a monthly arrangement, our packages ensure convenience and cost-effectiveness."
    },
    {
      "name": "Pune Corporate Transport Solutions",
      description: "AB Ghule Cabs offers efficient corporate transport solutions for businesses in Pune. Our services include group transport, airport transfers, and employee shuttles to streamline your corporate transportation needs."
    },
    {
      "name": "Pune Monthly Service Cabs",
      description: "Book monthly service cabs with AB Ghule Cabs for a reliable and cost-effective solution to your daily commuting needs. Our monthly packages are designed for businesses and individuals who need regular taxi services."
    },
    {
      "name": "Pune Monthly Cab Services",
      description: "AB Ghule Cabs offers monthly cab services for corporate and individual use in Pune. Enjoy the convenience of regular transportation with flexible rates and dependable service."
    },
    {
      "name": "Pune Monthly Taxi Hire",
      description: "Need a taxi on a monthly hire basis in Pune? AB Ghule Cabs offers monthly taxi hire services, providing you with a dedicated vehicle for your business or personal commuting needs."
    },
    {
      "name": "Pune Monthly Car Rental",
      description: "AB Ghule Cabs offers monthly car rental options for corporate or personal use in Pune. Rent a vehicle for a month and enjoy the convenience of having a well-maintained car whenever you need it."
    },
    {
      "name": "Pune Monthly Cab Booking",
      description: "Easily book monthly cabs with AB Ghule Cabs in Pune. Our simple online booking platform makes it easy to arrange monthly taxi services for regular travel."
    },
    {
      "name": "Pune Monthly Taxi Packages",
      description: "AB Ghule Cabs provides flexible monthly taxi packages in Pune, offering the best rates and services for businesses and individuals who need regular and reliable transport."
    },
    {
      "name": "Pune Monthly Car Lease",
      description: "Looking for a monthly car lease in Pune? AB Ghule Cabs offers leasing options for corporate clients, ensuring that your business has reliable transportation at competitive rates."
    },
    {
      "name": "Pune Monthly Cab Rates",
      description: "Check out our competitive monthly cab rates for businesses and individuals in Pune. AB Ghule Cabs offers cost-effective solutions for regular travel, with no hidden charges or extra costs."
    },
    {
      "name": "Pune Monthly Taxi Costs",
      description: "Get transparent and affordable monthly taxi costs with AB Ghule Cabs. Whether for business or personal use, our monthly taxi services in Pune provide great value."
    },
    {
      "name": "Pune Long-Term Cab Rentals",
      description: "For long-term cab rentals in Pune, AB Ghule Cabs offers flexible rental options. We provide well-maintained vehicles for extended use, ensuring comfort and reliability for all your travel needs."
    },
    {
      "name": "Corporate Cab Service in Pune Contact Number",
      description: "For corporate cab bookings or inquiries, contact AB Ghule Cabs at +91 8624029699. Our team is available to assist you with all your corporate travel needs."
    }
  ],

  tableData: [
    ["Pune Corporate Cab Services", "- Pune Corporate Taxi Booking"],
    ["Pune Corporate Car Rental", "- Pune Corporate Transportation Services"],
    ["Pune Corporate Car Hire", "- Pune Corporate Taxi Rates"],
    ["Pune Corporate Vehicle Rental", "- Pune Corporate Taxi Packages"],
    ["Pune Corporate Transport Solutions", "- Pune Monthly Service Cabs"],
    ["Pune Monthly Cab Services", "- Pune Monthly Taxi Hire"],
    ["Pune Monthly Car Rental", "- Pune Monthly Cab Booking"],
    ["Pune Monthly Taxi Packages", "- Pune Monthly Car Lease"],
    ["Pune Monthly Cab Rates", "- Pune Monthly Taxi Costs"],
    ["Pune Long-Term Cab Rentals", "- Corporate cab service in Pune contact number"]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Reliable and Professional Service",
      WhyChoosedescription: "AB Ghule Cabs offers reliable and professional corporate cab services in Pune. We understand the importance of timely and safe transportation for business needs, and our drivers ensure a smooth and comfortable experience for all corporate clients."
    },
    {
      WhyChooseheading: "On-Time Pick-Up and Drop-Off",
      WhyChoosedescription: "Timeliness is key in corporate travel. We prioritize punctuality to ensure that you or your employees reach meetings, events, and appointments on time, every time."
    },
    {
      WhyChooseheading: "Experienced and Well-Trained Drivers",
      WhyChoosedescription: "Our drivers are highly experienced and professionally trained to handle corporate passengers. They are courteous, discreet, and always maintain a high level of professionalism during business travel."
    },
    {
      WhyChooseheading: "Wide Range of Vehicles",
      WhyChoosedescription: "We offer a variety of vehicles suitable for corporate needs, from economical sedans to premium luxury cars and SUVs. Whether it’s a single ride or group transport, we have the right vehicle to suit your requirements."
    },
    {
      WhyChooseheading: "Affordable and Transparent Pricing",
      WhyChoosedescription: "AB Ghule Cabs provides cost-effective corporate cab services with transparent pricing. There are no hidden fees, and you will always know the fare upfront, ensuring clear expectations."
    },
    {
      WhyChooseheading: "Customized Corporate Packages",
      WhyChoosedescription: "We offer tailored solutions for businesses, whether it's regular employee transport, corporate event shuttles, or airport transfers. Our flexible service packages ensure that all your corporate travel needs are met efficiently."
    },
    {
      WhyChooseheading: "Comfortable and Safe Travel",
      WhyChoosedescription: "The safety and comfort of our passengers are our top priorities. All our vehicles are well-maintained, and equipped with the latest features, including air-conditioning, GPS, and safety systems for a smooth and secure ride."
    },
    {
      WhyChooseheading: "Easy Booking and Support",
      WhyChoosedescription: "Booking a corporate cab is hassle-free through our website or mobile app. Our customer service team is also available to assist you with bookings, modifications, and special requests."
    }
  ]
  
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a corporate cab service with AB Ghule Cabs?',
      answer: 'You can easily book a corporate cab through our website, mobile app, or by contacting our customer service team. We make the booking process simple and convenient.',
    },
    {
      id: 'FAQ2',
      question: 'What types of vehicles are available for corporate bookings?',
      answer: 'We offer a range of vehicles including sedans, SUVs, and luxury cars, catering to different corporate needs, whether it\'s for employee travel, client meetings, or business events.',
    },
    {
      id: 'FAQ3',
      question: 'Do you offer regular pick-up and drop-off services for employees?',
      answer: 'Yes, we provide regular pick-up and drop-off services for employees, ensuring timely and comfortable transport to and from the workplace.',
    },
    {
      id: 'FAQ4',
      question: 'Are the drivers professional and experienced?',
      answer: 'All of our drivers are professionally trained, experienced, and background-checked to ensure a safe and comfortable journey for corporate clients.',
    },
    {
      id: 'FAQ5',
      question: 'How do I manage bookings for multiple employees?',
      answer: 'We offer easy group bookings and customized solutions to manage transport for multiple employees, including airport transfers, office shuttles, and client pick-ups.',
    },
    {
      id: 'FAQ6',
      question: 'Do you provide airport transfers for corporate travel?',
      answer: 'Yes, we offer reliable airport transfer services for corporate clients, ensuring on-time pick-up and drop-off to and from Pune Airport for business travel.',
    },
    {
      id: 'FAQ7',
      question: 'What are the payment options for corporate bookings?',
      answer: 'We offer multiple payment methods, including credit/debit cards, cash, or online payment through our app, making it convenient for corporate clients.',
    },
    {
      id: 'FAQ8',
      question: 'Can I request a specific vehicle for my corporate travel?',
      answer: 'Yes, you can request a specific vehicle based on availability. We offer both standard and luxury options to cater to your preferences.',
    },
    {
      id: 'FAQ9',
      question: 'How do I cancel or modify my corporate cab booking?',
      answer: 'Modifications and cancellations can be done through our website, app, or by contacting our customer service team. We aim to make the process easy and flexible for you.',
    },
    {
      id: 'FAQ10',
      question: 'Why should I choose AB Ghule Cabs for corporate travel?',
      answer: 'AB Ghule Cabs stands out because of our reliability, professionalism, well-maintained fleet, and tailored solutions for businesses. We focus on providing safe, efficient, and comfortable travel for all your corporate needs.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Raghav Deshmukh, HR Manager, Tech Solutions Ltd.',
      feedback: 'AB Ghule Cabs has been our trusted partner for employee transport in Pune. Their drivers are always punctual, the vehicles are in excellent condition, and the service is very professional. They have made corporate travel smooth and hassle-free for our company. Highly recommended!',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Priya Sharma, Event Coordinator',
      feedback: 'We regularly use AB Ghule Cabs for our corporate events and client pick-ups. Their prompt service, professionalism, and attention to detail make them stand out from other cab services in Pune. We always get positive feedback from our employees and clients.',
      rating: 5,
    },
  ];
  





  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/gallery/Img for Gallery-600x400px-01.jpg", alt: "Image 1" },
    { src: "/images/gallery/Img for Gallery-600x400px-02.jpg", alt: "Image 2" },
    { src: "/images/gallery/Img for Gallery-600x400px-03.jpg", alt: "Image 3" },
    { src: "/images/gallery/Img for Gallery-600x400px-04.jpg", alt: "Image 4" },
    { src: "/images/gallery/Img for Gallery-600x400px-05.jpg", alt: "Image 5" },
    { src: "/images/gallery/Img for Gallery-600x400px-06.jpg", alt: "Image 6" },
    { src: "/images/gallery/Img for Gallery-600x400px-07.jpg", alt: "Image 7" },
    { src: "/images/gallery/Img for Gallery-600x400px-08.jpg", alt: "Image 8" },
    { src: "/images/gallery/Img for Gallery-600x400px-09.jpg", alt: "Image 9" },
    { src: "/images/gallery/Img for Gallery-600x400px-10.jpg", alt: "Image 10" },
    { src: "/images/gallery/Img for Gallery-600x400px-11.jpg", alt: "Image 11" },
    { src: "/images/gallery/Img for Gallery-600x400px-12.jpg", alt: "Image 12" },
    { src: "/images/gallery/Img for Gallery-600x400px-13.jpg", alt: "Image 13" },
    { src: "/images/gallery/Img for Gallery-600x400px-14.jpg", alt: "Image 14" },
    { src: "/images/gallery/Img for Gallery-600x400px-15.jpg", alt: "Image 15" },
  ];




  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Corporate Cab Service in Pune | Affordable Taxi Booking & Car Rental Services | AB Ghule Cabs</title>
  <meta name="description" content="Get professional corporate cab services in Pune with AB Ghule Cabs. Offering corporate taxi booking, vehicle rental, long-term cab rentals, and monthly cab services for businesses. Call +91 8624029699 for bookings." />
  <meta name="keywords" content="Pune Corporate Cab Services, Pune Corporate Taxi Booking, Pune Corporate Car Rental, Pune Corporate Transportation Services, Pune Corporate Car Hire, Pune Corporate Taxi Rates, Pune Corporate Vehicle Rental, Pune Corporate Taxi Packages, Pune Corporate Transport Solutions, Pune Monthly Service Cabs, Pune Monthly Cab Services, Pune Monthly Taxi Hire, Pune Monthly Car Rental, Pune Monthly Cab Booking, Pune Monthly Taxi Packages, Pune Monthly Car Lease, Pune Monthly Cab Rates, Pune Monthly Taxi Costs, Pune Long-Term Cab Rentals, Corporate cab service in Pune contact number" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Corporate Cab Service in Pune | Affordable Taxi Booking & Car Rental Services | AB Ghule Cabs" />
  <meta property="og:description" content="Get professional corporate cab services in Pune with AB Ghule Cabs. Offering corporate taxi booking, vehicle rental, long-term cab rentals, and monthly cab services for businesses. Call +91 8624029699 for bookings." />
  <meta property="og:image" content="https://abghulecabs.com/images/corporate-cab-service.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/corporate-cab-service" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Corporate Cab Service in Pune",
        description: "Get professional corporate cab services in Pune with AB Ghule Cabs. Offering corporate taxi booking, vehicle rental, long-term cab rentals, and monthly cab services for businesses. Call +91 8624029699 for bookings.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/corporate-cab-service",
        "logo": "https://abghulecabs.com/images/corporate-cab-service.jpg",
        "image": "https://abghulecabs.com/images/corporate-cab-service.jpg",
        "priceRange": "₹500 - ₹10000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/corporate-cab-service",
          "priceCurrency": "INR",
          "price": "500",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "120"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Siddhi A"
            },
            "datePublished": "2024-11-10",
            "reviewBody": "We’ve been using AB Ghule Cabs for our corporate needs for over a year. Excellent service, punctual drivers, and affordable rates. Highly recommended for businesses."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Manoj R"
            },
            "datePublished": "2024-10-12",
            "reviewBody": "Their monthly cab service is great. We have been using them for our office commute, and they provide reliable and professional drivers at competitive rates."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Corporate Cab Service in Pune",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/corporate-cab-service"
        },
        "keywords": "Pune Corporate Cab Services, Pune Corporate Taxi Booking, Pune Corporate Car Rental, Pune Corporate Transportation Services, Pune Corporate Car Hire, Pune Corporate Taxi Rates, Pune Corporate Vehicle Rental, Pune Corporate Taxi Packages, Pune Corporate Transport Solutions, Pune Monthly Service Cabs, Pune Monthly Cab Services, Pune Monthly Taxi Hire, Pune Monthly Car Rental, Pune Monthly Cab Booking, Pune Monthly Taxi Packages, Pune Monthly Car Lease, Pune Monthly Cab Rates, Pune Monthly Taxi Costs, Pune Long-Term Cab Rentals, Corporate cab service in Pune contact number"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/34.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Corporatecabserviceinpune;